import React from 'react';
import { bool, func, string } from 'prop-types';

// Components
import { Button, CircularProgress } from '@mui/material';

import { styled } from '@mui/material/styles';

const ButtonProgress = styled(CircularProgress)(({ theme }) => ({
  bottom: 0,
  color: theme.palette.secondary.main,
  left: 0,
  margin: 'auto',
  pointerEvents: 'none',
  position: 'absolute',
  right: 0,
  top: 0,
}));

const ButtonsDiv = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  bottom: 0,
  boxShadow: theme.shadows[0],
  display: 'flex',
  flexShrink: 0,
  gridColumnGap: theme.spacing(2),
  height: 68,
  justifyContent: 'center',
  left: 0,
  padding: theme.spacing(3, 2),
  position: 'sticky',
  width: '100%',
  zIndex: 3,
}));

const Buttons = ({
  handleLeftButtonClick,
  handleRightButtonClick,
  disabled,
  loadingData,
  leftLabel,
  rightLabel,
}) => {
  return (
    <ButtonsDiv>
      <Button disabled={loadingData} fullWidth onClick={handleLeftButtonClick} variant="outlined">
        {loadingData && <ButtonProgress size={14} />}
        {leftLabel}
      </Button>
      <Button
        disabled={disabled || loadingData}
        fullWidth
        onClick={handleRightButtonClick}
        variant="contained"
      >
        {loadingData && <ButtonProgress size={14} />}
        {rightLabel}
      </Button>
    </ButtonsDiv>
  );
};

Buttons.propTypes = {
  disabled: bool,
  handleLeftButtonClick: func.isRequired,
  handleRightButtonClick: func.isRequired,
  leftLabel: string.isRequired,
  loadingData: bool,
  rightLabel: string.isRequired,
};

Buttons.defaultProps = {
  disabled: false,
  loadingData: false,
};

export default Buttons;
